import { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Loading from "components/Loading";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import DndMultipleContainers from "components/elements/DndMultipleContainers";
import { exportOrder } from "actions/orderActions";
import { formatterCreateAt } from "components/Function";
import { CSVLink } from "react-csv";
import { listShippingMethod } from "helper/constant";

function Modalexportorders(props) {
    const [export_orders_data, setExportOrdersData] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);
    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);
    const [timezone, setTimezone] = useState("Asia/Ho_Chi_Minh");
    const [include_cancelled_orders, setIncludeCancelledOrders] = useState(false);
    const [fill_in_all_rows, setFillInAllRows] = useState(false);

    var { isLoading, all_orders_for_export } = props.order;
    var { isOpenModalExportOrders, openModal, formatterCreateAt, orders_selected, list_staff, exportOrder } = props;
    const { t } = useTranslation();

    useEffect(() => {
        var export_orders_columns = localStorage.getItem("export_orders_columns");
        if (export_orders_columns) {
            setLeftItems(JSON.parse(export_orders_columns)?.left_items);
            setRightItems(JSON.parse(export_orders_columns)?.right_items);
            setTimezone(JSON.parse(export_orders_columns)?.timezone);
            setIncludeCancelledOrders(JSON.parse(export_orders_columns)?.include_cancelled_orders);
            setFillInAllRows(JSON.parse(export_orders_columns)?.fill_in_all_rows);
        } else {
            setLeftItems([
                { id: "fulfill_note", label: "fulfill_note" },
                { id: "printer", label: "printer" },
                { id: "fulfillment_order_id", label: "fulfillment_order_id" },
                { id: "base_cost", label: "base_cost" },
                { id: "design_fee", label: "design_fee" },
                { id: "shipping_fee", label: "shipping_fee" },
                { id: "is_replacement_order", label: "is_replacement_order" },
                { id: "is_sample_order", label: "is_sample_order" },
                { id: "affiliate_order", label: "affiliate_order" },
                { id: "affiliate_amount", label: "affiliate_amount" },
                { id: "delivery_sla_time", label: "delivery_sla_time" },
                { id: "delivery_time", label: "delivery_time" },
                { id: "payment_method_name", label: "payment_method_name" },
                { id: "prof", label: "prof" },
                { id: "earn", label: "earn" },
                { id: "earn_payout", label: "earn_payout" },
                { id: "label_fee", label: "label_fee" },
                { id: "statement_amount", label: "statement_amount" },
                { id: "address_line1", label: "address_line1" },
                { id: "address_line2", label: "address_line2" },
                { id: "city", label: "city" },
                { id: "state", label: "state" },
                { id: "country", label: "country" },
                { id: "zip", label: "zip" },
                { id: "sku_id", label: "sku_id" },
                { id: "shipping_method", label: "shipping_method" },
                { id: "variant_id", label: "variant_id" },
                { id: "printing_area", label: "printing_area" },
                { id: "first_name", label: "first_name" },
                { id: "last_name", label: "last_name" },
                { id: "region_code", label: "region_code" },
                { id: "color", label: "color" },
                { id: "size", label: "size" },
                { id: "seller_note", label: "seller_note" },
                { id: "category_tiktok", label: "category_tiktok" },
            ]);
            setRightItems([
                { id: "id", label: "id" },
                { id: "status", label: "status" },
                { id: "title", label: "title" },
                { id: "main_images", label: "main_images" },
                { id: "image", label: "image" },
                { id: "design_front", label: "design_front" },
                { id: "design_back", label: "design_back" },
                { id: "design_neck", label: "design_neck" },
                { id: "design_right", label: "design_right" },
                { id: "design_left", label: "design_left" },
                { id: "design_aop_3d", label: "design_aop_3d" },
                { id: "mockup_front", label: "mockup_front" },
                { id: "mockup_back", label: "mockup_back" },
                { id: "mockup_neck", label: "mockup_neck" },
                { id: "mockup_right", label: "mockup_right" },
                { id: "mockup_left", label: "mockup_left" },
                { id: "mockup_aop_3d", label: "mockup_aop_3d" },
                { id: "total_item", label: "total_item" },
                { id: "quantity", label: "quantity" },
                { id: "skus", label: "skus" },
                { id: "seller_sku", label: "seller_sku" },
                { id: "label", label: "label" },
                { id: "tracking_number", label: "tracking_number" },
                { id: "price", label: "price" },
                { id: "est", label: "est" },
                { id: "name", label: "name" },
                { id: "address", label: "address" },
                { id: "phone", label: "phone" },
                { id: "buyer_note", label: "buyer_note" },
                { id: "shop_name", label: "shop_name" },
                { id: "shop_note", label: "shop_note" },
                { id: "email_member", label: "email_member" },
                { id: "create_time", label: "create_time" },
            ]);
            setTimezone("Asia/Ho_Chi_Minh");
            setIncludeCancelledOrders(false);
        }
    }, []);

    useEffect(() => {
        if (all_orders_for_export.length > 0) {
            var export_orders_data = [];
            for (var i = 0; i < all_orders_for_export.length; i++) {
                if (orders_selected.length > 0) {
                    if (!orders_selected.includes(all_orders_for_export[i]._id)) {
                        continue;
                    }
                }
                var rev = all_orders_for_export[i]?.est_amount > 0
                    ? all_orders_for_export[i]?.est_amount
                    : (all_orders_for_export[i]?.shipping_type === "TIKTOK"
                        ? ((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax))
                        : ((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount + +all_orders_for_export[i]?.payment?.shipping_fee) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax))
                    )
                var ff = (all_orders_for_export[i]?.base_cost || 0) + (all_orders_for_export[i]?.design_fee ? Object.values(all_orders_for_export[i]?.design_fee).reduce((a, b) => +a + +b, 0) : 0);
                var prof = (rev - ff) / rev * 100;
                var earn = rev - ff;
                var shipfee = +all_orders_for_export[i]?.payment?.original_shipping_fee > 0 && +all_orders_for_export[i]?.payment?.shipping_fee === 0 && +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount === +all_orders_for_export[i]?.payment?.original_shipping_fee ? +all_orders_for_export[i]?.payment?.original_shipping_fee : +all_orders_for_export[i]?.payment?.original_shipping_fee === 0 && +all_orders_for_export[i]?.payment?.shipping_fee === 0 ? 0 : +all_orders_for_export[i]?.payment?.original_shipping_fee > +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount && +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount > 0 && +all_orders_for_export[i]?.payment?.shipping_fee === 0 ? +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount : +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount === 0 && +all_orders_for_export[i]?.payment?.shipping_fee > 0 ? 0 : +all_orders_for_export[i]?.payment?.shipping_fee_seller_discount;

                for (var j = 0; j < all_orders_for_export[i]?.line_items.length; j++) {
                    var export_orders_data_tmp = {
                        id: (j === 0 || fill_in_all_rows) ? "'" + all_orders_for_export[i]?.apiOrderId : "",
                        status: j === 0 ? all_orders_for_export[i]?.status : "",
                        title: all_orders_for_export[i]?.line_items[j]?.product_name.replace(/"/g, '""'),
                        main_images: all_orders_for_export[i]?.line_items[j]?.main_images.join("|"),
                        image: all_orders_for_export[i]?.line_items[j]?.sku_image,
                        design_front: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Front || "",
                        design_back: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Back || "",
                        design_neck: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Neck || "",
                        design_right: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Right || "",
                        design_left: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.Left || "",
                        design_aop_3d: all_orders_for_export[i]?.design?.[all_orders_for_export[i]?.line_items[j]?.id]?.AOP_3D || "",
                        mockup_front: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Front || "",
                        mockup_back: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Back || "",
                        mockup_neck: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Neck || "",
                        mockup_right: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Right || "",
                        mockup_left: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.Left || "",
                        mockup_aop_3d: all_orders_for_export[i]?.mockup?.[all_orders_for_export[i]?.line_items[j]?.id]?.AOP_3D || "",
                        total_item: j === 0 ? all_orders_for_export[i]?.line_items?.length : "",
                        quantity: Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.quantity || "1",
                        skus: all_orders_for_export[i]?.line_items[j]?.sku_name,
                        seller_sku: "'" + all_orders_for_export[i]?.line_items[j]?.seller_sku,
                        label: (j === 0 || fill_in_all_rows) ? all_orders_for_export[i]?.shipping_label : "",
                        tracking_number: (j === 0 || fill_in_all_rows) ? "'" + all_orders_for_export[i]?.tracking_number: "",
                        price: j === 0 ? all_orders_for_export[i]?.payment.total_amount : "",
                        est: j === 0 ? all_orders_for_export[i]?.est_amount > 0 ? all_orders_for_export[i]?.est_amount : all_orders_for_export[i]?.shipping_type === "TIKTOK" ? (((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax)).toFixed(2)) : ((+all_orders_for_export[i]?.payment?.original_total_product_price - +all_orders_for_export[i]?.payment?.seller_discount + +all_orders_for_export[i]?.payment?.shipping_fee) - 6 / 100 * (+all_orders_for_export[i]?.payment?.total_amount + +all_orders_for_export[i]?.payment?.platform_discount - +all_orders_for_export[i]?.payment?.tax)).toFixed(2) : "",
                        name: j === 0 ? all_orders_for_export[i]?.recipient_address.name : "",
                        address: j === 0 ? (all_orders_for_export[i]?.recipient_address?.delivery_preferences?.drop_off_location && all_orders_for_export[i]?.recipient_address?.delivery_preferences?.drop_off_location !== "" ? `Delivery instructions: ${all_orders_for_export[i]?.recipient_address?.delivery_preferences?.drop_off_location}\n` : "") + (
                            all_orders_for_export[i]?.recipient_address?.region_code === "US" ?
                                all_orders_for_export[i]?.recipient_address?.address_detail + ", " + (all_orders_for_export[i]?.recipient_address?.address_line2 ? all_orders_for_export[i]?.recipient_address?.address_line2 + ", " : "") + (all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "City")?.address_name ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "City")?.address_name + ", " : "") + (all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "State")?.address_name ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "State")?.address_name + ", " : "") + (all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "Country")?.address_name ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "Country")?.address_name + ", " : "") + (all_orders_for_export[i]?.recipient_address?.postal_code ? all_orders_for_export[i]?.recipient_address?.postal_code : "")
                                :
                                all_orders_for_export[i]?.recipient_address?.address_detail + ", " + (all_orders_for_export[i].recipient_address?.address_line2 ? all_orders_for_export[i].recipient_address?.address_line2 + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[3]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[3]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_name && all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_level_name !== "County" ? all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[1]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[1]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.district_info?.[0]?.address_name ? all_orders_for_export[i].recipient_address?.district_info?.[0]?.address_name + ", " : "") + (all_orders_for_export[i].recipient_address?.postal_code ? all_orders_for_export[i].recipient_address?.postal_code : "")
                        ): "",
                        phone: j === 0 ? all_orders_for_export[i]?.recipient_address.phone_number : "",
                        buyer_note: j === 0 ? all_orders_for_export[i]?.buyer_message : "",
                        shop_name: j === 0 ? all_orders_for_export[i]?.shops?.name : "",
                        shop_note: j === 0 ? all_orders_for_export[i]?.shops?.note : "",
                        email_member: j === 0 ? list_staff?.find((v2, i2) => v2?.value === all_orders_for_export[i]?.createdBy)?.label : "",
                        create_time: j === 0 ? formatterCreateAt(all_orders_for_export[i]?.create_time * 1000, "full", timezone) : "",
                        fulfill_note: j === 0 ? all_orders_for_export[i]?.keywords : "",
                        printer: j === 0 ? (Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.printer || "") : "",
                        fulfillment_order_id: all_orders_for_export[i]?.fulfillment_order_id,
                        base_cost: j === 0 ? (all_orders_for_export[i]?.base_cost || "0") : "0",
                        design_fee: j === 0 ? (all_orders_for_export[i]?.design_fee ? Object.values(all_orders_for_export[i]?.design_fee).reduce((a, b) => +a + +b, 0) : "0") : "0",
                        shipping_fee: j === 0 ? shipfee : "",
                        is_free_shipping: j === 0 ? (shipfee ? true : false) : "",
                        is_replacement_order: j === 0 ? (all_orders_for_export[i]?.is_replacement_order ? "replacement" : "") : "",
                        is_sample_order: j === 0 ? (all_orders_for_export[i]?.is_sample_order ? "sample order" : "") : "",
                        affiliate_order: j === 0 ? (all_orders_for_export[i]?.affiliate_order ? "order affiliate" : "") : "",
                        affiliate_amount: j === 0 ? (all_orders_for_export[i]?.affiliate_amount || "0") : "0",
                        delivery_sla_time: j === 0 ? (all_orders_for_export[i]?.delivery_sla_time ? formatterCreateAt(all_orders_for_export[i]?.delivery_sla_time * 1000, "full", timezone) : "") : "",
                        delivery_time: j === 0 ? (all_orders_for_export[i]?.delivery_time ? formatterCreateAt(all_orders_for_export[i]?.delivery_time * 1000, "full", timezone) : "") : "",
                        payment_method_name: j === 0 ? all_orders_for_export[i]?.payment_method_name : "",
                        prof: j === 0 ? prof.toFixed(2) : "",
                        earn: j === 0 ? earn.toFixed(2) : "",
                        earn_payout: j === 0 ? (earn - shipfee).toFixed(2) : "",
                        label_fee: j === 0 ? all_orders_for_export[i]?.shipping_service_info_price?.toFixed(2) : "",
                        statement_amount: j === 0 ? all_orders_for_export[i]?.statement_amount?.toFixed(2) : "",
                        address_line1: j === 0 ? all_orders_for_export[i]?.recipient_address?.address_line1 : "",
                        address_line2: j === 0 ? all_orders_for_export[i]?.recipient_address?.address_line2 : "",
                        city: j === 0 ? (all_orders_for_export[i]?.recipient_address?.region_code === "US" ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "City")?.address_name : all_orders_for_export[i].recipient_address?.district_info?.[2]?.address_name) : "",
                        state: j === 0 ? (all_orders_for_export[i]?.recipient_address?.region_code === "US" ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "State")?.address_name : "") : "",
                        country: j === 0 ? (all_orders_for_export[i]?.recipient_address?.region_code === "US" ? all_orders_for_export[i]?.recipient_address?.district_info?.find((v) => v?.address_level_name === "Country")?.address_name : all_orders_for_export[i].recipient_address?.district_info?.[1]?.address_name) : "",
                        zip: j === 0 ? all_orders_for_export[i].recipient_address?.postal_code : "",
                        sku_id: "'" + all_orders_for_export[i]?.line_items[j]?.sku_id,
                        shipping_method: j === 0 ? (listShippingMethod.find((v2, i2) => v2.value == Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.shipping_method && v2.enabled.includes(Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.printer))?.label || "") : "",
                        variant_id: `${!isNaN(+Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.variant_id) ? "'" : ""}${Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.variant_id || ""}`,
                        printing_area: Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.printing_area || "",
                        first_name: j === 0 ? all_orders_for_export[i]?.recipient_address?.first_name : "",
                        last_name: j === 0 ? all_orders_for_export[i]?.recipient_address?.last_name : "",
                        region_code: j === 0 ? all_orders_for_export[i]?.recipient_address?.region_code : "",
                        color: Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.color || "",
                        size: Object.values(all_orders_for_export[i]?.printer || {})?.[0]?.size || "",
                        seller_note: j === 0 ? all_orders_for_export[i]?.recipient_address?.seller_note : "",
                        category_tiktok: all_orders_for_export[i]?.line_items[j]?.category_tiktok,
                    }
                    for (var k = 0; k < leftItems.length; k++) {
                        delete export_orders_data_tmp[leftItems[k].id];
                    }
                    const sortedData = {};
                    for (var l = 0; l < rightItems.length; l++) {
                        const key = rightItems[l].id;
                        if (export_orders_data_tmp.hasOwnProperty(key)) {
                            sortedData[key] = export_orders_data_tmp[key];

                            if (key === "shipping_fee" && export_orders_data_tmp.hasOwnProperty("is_free_shipping")) {
                                sortedData["is_free_shipping"] = export_orders_data_tmp["is_free_shipping"];
                            }
                        }
                    }
                    export_orders_data.push(sortedData);
                }
                // export_orders_data.push({});
            }
            setExportOrdersData(export_orders_data);
            setInitiateDownload(true);
        }
    }, [all_orders_for_export, formatterCreateAt]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    const onClickExportOrders = () => {
        localStorage.setItem("export_orders_columns", JSON.stringify({ left_items: leftItems, right_items: rightItems, timezone, include_cancelled_orders, fill_in_all_rows }));
        exportOrder(props.exportorders.searchText + "|cotik|" + orders_selected.join(","), props.exportorders.filter_printer, props.exportorders.filter_shop_code, props.exportorders.filter_status, props.exportorders.filter_work_status, props.exportorders.filter_staff_note, props.exportorders.filter_staff, props.exportorders.filter_order_design, props.exportorders.filter_shipping_type, props.exportorders.dateStart_tmp, props.exportorders.dateEnd_tmp, include_cancelled_orders);
    }

    const onClickResetDefault = () => {
        setLeftItems([
            { id: "fulfill_note", label: "fulfill_note" },
            { id: "printer", label: "printer" },
            { id: "fulfillment_order_id", label: "fulfillment_order_id" },
            { id: "base_cost", label: "base_cost" },
            { id: "design_fee", label: "design_fee" },
            { id: "shipping_fee", label: "shipping_fee" },
            { id: "is_replacement_order", label: "is_replacement_order" },
            { id: "is_sample_order", label: "is_sample_order" },
            { id: "affiliate_order", label: "affiliate_order" },
            { id: "affiliate_amount", label: "affiliate_amount" },
            { id: "delivery_sla_time", label: "delivery_sla_time" },
            { id: "delivery_time", label: "delivery_time" },
            { id: "payment_method_name", label: "payment_method_name" },
            { id: "prof", label: "prof" },
            { id: "earn", label: "earn" },
            { id: "earn_payout", label: "earn_payout" },
            { id: "label_fee", label: "label_fee" },
            { id: "statement_amount", label: "statement_amount" },
            { id: "address_line1", label: "address_line1" },
            { id: "address_line2", label: "address_line2" },
            { id: "city", label: "city" },
            { id: "state", label: "state" },
            { id: "country", label: "country" },
            { id: "zip", label: "zip" },
            { id: "sku_id", label: "sku_id" },
            { id: "shipping_method", label: "shipping_method" },
            { id: "variant_id", label: "variant_id" },
            { id: "printing_area", label: "printing_area" },
            { id: "first_name", label: "first_name" },
            { id: "last_name", label: "last_name" },
            { id: "region_code", label: "region_code" },
            { id: "color", label: "color" },
            { id: "size", label: "size" },
            { id: "seller_note", label: "seller_note" },
            { id: "category_tiktok", label: "category_tiktok" },
        ]);
        setRightItems([
            { id: "id", label: "id" },
            { id: "status", label: "status" },
            { id: "title", label: "title" },
            { id: "main_images", label: "main_images" },
            { id: "image", label: "image" },
            { id: "design_front", label: "design_front" },
            { id: "design_back", label: "design_back" },
            { id: "design_neck", label: "design_neck" },
            { id: "design_right", label: "design_right" },
            { id: "design_left", label: "design_left" },
            { id: "design_aop_3d", label: "design_aop_3d" },
            { id: "mockup_front", label: "mockup_front" },
            { id: "mockup_back", label: "mockup_back" },
            { id: "mockup_neck", label: "mockup_neck" },
            { id: "mockup_right", label: "mockup_right" },
            { id: "mockup_left", label: "mockup_left" },
            { id: "mockup_aop_3d", label: "mockup_aop_3d" },
            { id: "total_item", label: "total_item" },
            { id: "quantity", label: "quantity" },
            { id: "skus", label: "skus" },
            { id: "seller_sku", label: "seller_sku" },
            { id: "label", label: "label" },
            { id: "tracking_number", label: "tracking_number" },
            { id: "price", label: "price" },
            { id: "est", label: "est" },
            { id: "name", label: "name" },
            { id: "address", label: "address" },
            { id: "phone", label: "phone" },
            { id: "buyer_note", label: "buyer_note" },
            { id: "shop_name", label: "shop_name" },
            { id: "shop_note", label: "shop_note" },
            { id: "email_member", label: "email_member" },
            { id: "create_time", label: "create_time" },
        ]);
        setTimezone("Asia/Ho_Chi_Minh");
        setIncludeCancelledOrders(false);
    };

    const onChange = (e) => {
        if (e.target.name === "timezone") {
            setTimezone(e.target.value);
        }
        if (e.target.name === "include_cancelled_orders") {
            setIncludeCancelledOrders(e.target.checked);
        }
        if (e.target.name === "fill_in_all_rows") {
            setFillInAllRows(e.target.checked);
        }
    }

    const onOpenModal = () => {
        openModal();
    };

    return (
        <Fragment>
            <Modal centered={true} size="lg" toggle={() => { onOpenModal() }} isOpen={isOpenModalExportOrders}>
                <Loading isLoading={isLoading} />
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Export Orders")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-8">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="">{t("Timezone for create_time")}</span>
                            </label>
                            <select name="timezone" value={timezone} className="form-select form-select-solid form-select-lg fw-semibold" onChange={(e) => { onChange(e) }} >
                                <option value="" data-value="">
                                    Select a default time zone ...{" "}
                                </option>
                                <option value="Etc/GMT+12" data-value="-12">
                                    (GMT-12:00) International Date Line West
                                </option>
                                <option value="Pacific/Midway" data-value="-11">
                                    (GMT-11:00) Midway Island, Samoa
                                </option>
                                <option value="Pacific/Honolulu" data-value="-10">
                                    (GMT-10:00) Hawaii
                                </option>
                                <option value="US/Alaska" data-value="-9">
                                    (GMT-09:00) Alaska
                                </option>
                                <option value="America/Los_Angeles" data-value="-8">
                                    (GMT-08:00) Pacific Time (US & Canada)
                                </option>
                                <option value="America/Tijuana" data-value="-8">
                                    (GMT-08:00) Tijuana, Baja California
                                </option>
                                <option value="US/Arizona" data-value="-7">
                                    (GMT-07:00) Arizona
                                </option>
                                <option value="America/Chihuahua" data-value="-7">
                                    (GMT-07:00) Chihuahua, La Paz, Mazatlan
                                </option>
                                <option value="US/Mountain" data-value="-7">
                                    (GMT-07:00) Mountain Time (US & Canada)
                                </option>
                                <option value="America/Managua" data-value="-6">
                                    (GMT-06:00) Central America
                                </option>
                                <option value="US/Central" data-value="-6">
                                    (GMT-06:00) Central Time (US & Canada)
                                </option>
                                <option value="America/Mexico_City" data-value="-6">
                                    (GMT-06:00) Guadalajara, Mexico City, Monterrey
                                </option>
                                <option value="Canada/Saskatchewan" data-value="-6">
                                    (GMT-06:00) Saskatchewan
                                </option>
                                <option value="America/Bogota" data-value="-5">
                                    (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                                </option>
                                <option value="US/Eastern" data-value="-5">
                                    (GMT-05:00) Eastern Time (US & Canada)
                                </option>
                                <option value="US/East-Indiana" data-value="-5">
                                    (GMT-05:00) Indiana (East)
                                </option>
                                <option value="Canada/Atlantic" data-value="-4">
                                    (GMT-04:00) Atlantic Time (Canada)
                                </option>
                                <option value="America/Caracas" data-value="-4">
                                    (GMT-04:00) Caracas, La Paz
                                </option>
                                <option value="America/Manaus" data-value="-4">
                                    (GMT-04:00) Manaus
                                </option>
                                <option value="America/Santiago" data-value="-4">
                                    (GMT-04:00) Santiago
                                </option>
                                <option value="Canada/Newfoundland" data-value="-3.5">
                                    (GMT-03:30) Newfoundland
                                </option>
                                <option value="America/Sao_Paulo" data-value="-3">
                                    (GMT-03:00) Brasilia
                                </option>
                                <option value="America/Argentina/Buenos_Aires" data-value="-3">
                                    (GMT-03:00) Buenos Aires, Georgetown
                                </option>
                                <option value="America/Godthab" data-value="-3">
                                    (GMT-03:00) Greenland
                                </option>
                                <option value="America/Montevideo" data-value="-3">
                                    (GMT-03:00) Montevideo
                                </option>
                                <option value="America/Noronha" data-value="-2">
                                    (GMT-02:00) Mid-Atlantic
                                </option>
                                <option value="Atlantic/Cape_Verde" data-value="-1">
                                    (GMT-01:00) Cape Verde Is.
                                </option>
                                <option value="Atlantic/Azores" data-value="-1">
                                    (GMT-01:00) Azores
                                </option>
                                <option value="Africa/Casablanca" data-value="0">
                                    (GMT+00:00) Casablanca, Monrovia, Reykjavik
                                </option>
                                <option value="Etc/Greenwich" data-value="0">
                                    (GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London
                                </option>
                                <option value="Europe/Amsterdam" data-value="1">
                                    (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna
                                </option>
                                <option value="Europe/Belgrade" data-value="1">
                                    (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague
                                </option>
                                <option value="Europe/Brussels" data-value="1">
                                    (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                                </option>
                                <option value="Europe/Sarajevo" data-value="1">
                                    (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb
                                </option>
                                <option value="Africa/Lagos" data-value="1">
                                    (GMT+01:00) West Central Africa
                                </option>
                                <option value="Asia/Amman" data-value="2">
                                    (GMT+02:00) Amman
                                </option>
                                <option value="Europe/Athens" data-value="2">
                                    (GMT+02:00) Athens, Bucharest, Istanbul
                                </option>
                                <option value="Asia/Beirut" data-value="2">
                                    (GMT+02:00) Beirut
                                </option>
                                <option value="Africa/Cairo" data-value="2">
                                    (GMT+02:00) Cairo
                                </option>
                                <option value="Africa/Harare" data-value="2">
                                    (GMT+02:00) Harare, Pretoria
                                </option>
                                <option value="Europe/Helsinki" data-value="2">
                                    (GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius
                                </option>
                                <option value="Asia/Jerusalem" data-value="2">
                                    (GMT+02:00) Jerusalem
                                </option>
                                <option value="Europe/Minsk" data-value="2">
                                    (GMT+02:00) Minsk
                                </option>
                                <option value="Africa/Windhoek" data-value="2">
                                    (GMT+02:00) Windhoek
                                </option>
                                <option value="Asia/Kuwait" data-value="3">
                                    (GMT+03:00) Kuwait, Riyadh, Baghdad
                                </option>
                                <option value="Europe/Moscow" data-value="3">
                                    (GMT+03:00) Moscow, St. Petersburg, Volgograd
                                </option>
                                <option value="Africa/Nairobi" data-value="3">
                                    (GMT+03:00) Nairobi
                                </option>
                                <option value="Asia/Tbilisi" data-value="3">
                                    (GMT+03:00) Tbilisi
                                </option>
                                <option value="Asia/Tehran" data-value="3.5">
                                    (GMT+03:30) Tehran
                                </option>
                                <option value="Asia/Muscat" data-value="4">
                                    (GMT+04:00) Abu Dhabi, Muscat
                                </option>
                                <option value="Asia/Baku" data-value="4">
                                    (GMT+04:00) Baku
                                </option>
                                <option value="Asia/Yerevan" data-value="4">
                                    (GMT+04:00) Yerevan
                                </option>
                                <option value="Asia/Kabul" data-value="4.5">
                                    (GMT+04:30) Kabul
                                </option>
                                <option value="Asia/Yekaterinburg" data-value="5">
                                    (GMT+05:00) Yekaterinburg
                                </option>
                                <option value="Asia/Karachi" data-value="5">
                                    (GMT+05:00) Islamabad, Karachi, Tashkent
                                </option>
                                <option value="Asia/Calcutta" data-value="5.5">
                                    (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                                </option>
                                <option value="Asia/Calcutta" data-value="5.5">
                                    (GMT+05:30) Sri Jayawardenapura
                                </option>
                                <option value="Asia/Katmandu" data-value="5.75">
                                    (GMT+05:45) Kathmandu
                                </option>
                                <option value="Asia/Almaty" data-value="6">
                                    (GMT+06:00) Almaty, Novosibirsk
                                </option>
                                <option value="Asia/Dhaka" data-value="6">
                                    (GMT+06:00) Astana, Dhaka
                                </option>
                                <option value="Asia/Rangoon" data-value="6.5">
                                    (GMT+06:30) Yangon (Rangoon)
                                </option>
                                <option value="Asia/Ho_Chi_Minh" data-value="7">
                                    (GMT+07:00) Bangkok, Hanoi, Jakarta
                                </option>
                                <option value="Asia/Krasnoyarsk" data-value="7">
                                    (GMT+07:00) Krasnoyarsk
                                </option>
                                <option value="Asia/Hong_Kong" data-value="8">
                                    (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                                </option>
                                <option value="Asia/Kuala_Lumpur" data-value="8">
                                    (GMT+08:00) Kuala Lumpur, Singapore
                                </option>
                                <option value="Asia/Irkutsk" data-value="8">
                                    (GMT+08:00) Irkutsk, Ulaan Bataar
                                </option>
                                <option value="Australia/Perth" data-value="8">
                                    (GMT+08:00) Perth
                                </option>
                                <option value="Asia/Taipei" data-value="8">
                                    (GMT+08:00) Taipei
                                </option>
                                <option value="Asia/Tokyo" data-value="9">
                                    (GMT+09:00) Osaka, Sapporo, Tokyo
                                </option>
                                <option value="Asia/Seoul" data-value="9">
                                    (GMT+09:00) Seoul
                                </option>
                                <option value="Asia/Yakutsk" data-value="9">
                                    (GMT+09:00) Yakutsk
                                </option>
                                <option value="Australia/Adelaide" data-value="9.5">
                                    (GMT+09:30) Adelaide
                                </option>
                                <option value="Australia/Darwin" data-value="9.5">
                                    (GMT+09:30) Darwin
                                </option>
                                <option value="Australia/Brisbane" data-value="10">
                                    (GMT+10:00) Brisbane
                                </option>
                                <option value="Australia/Canberra" data-value="10">
                                    (GMT+10:00) Canberra, Melbourne, Sydney
                                </option>
                                <option value="Australia/Hobart" data-value="10">
                                    (GMT+10:00) Hobart
                                </option>
                                <option value="Pacific/Guam" data-value="10">
                                    (GMT+10:00) Guam, Port Moresby
                                </option>
                                <option value="Asia/Vladivostok" data-value="10">
                                    (GMT+10:00) Vladivostok
                                </option>
                                <option value="Asia/Magadan" data-value="11">
                                    (GMT+11:00) Magadan, Solomon Is., New Caledonia
                                </option>
                                <option value="Pacific/Auckland" data-value="12">
                                    (GMT+12:00) Auckland, Wellington
                                </option>
                                <option value="Pacific/Fiji" data-value="12">
                                    (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                                </option>
                                <option value="Pacific/Tongatapu" data-value="13">
                                    (GMT+13:00) Nuku'alofa
                                </option>
                            </select>
                        </div>
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-4">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span>&nbsp;</span>
                            </label>
                            <button onClick={() => { onClickResetDefault() }} type="button" className="btn btn-primary">
                                {t("Reset default")}
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-12">
                            <div className="form-check form-check-solid form-check-custom fv-row">
                                <input type="checkbox" className="form-check-input" value={!include_cancelled_orders} id="include_cancelled_orders" name="include_cancelled_orders" checked={include_cancelled_orders} onChange={(e) => { onChange(e) }} />
                                <label className="form-check-label fs-6 fw-semibold text-dark" htmlFor="include_cancelled_orders">{t("Include Cancelled Orders in Export")}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container col-12">
                            <div className="form-check form-check-solid form-check-custom fv-row">
                                <input type="checkbox" className="form-check-input" value={!fill_in_all_rows} id="fill_in_all_rows" name="fill_in_all_rows" checked={fill_in_all_rows} onChange={(e) => { onChange(e) }} />
                                <label className="form-check-label fs-6 fw-semibold text-dark" htmlFor="fill_in_all_rows">{t("Fill in all rows")}</label>
                            </div>
                        </div>
                    </div>
                    <DndMultipleContainers leftItems={leftItems} setLeftItems={setLeftItems} rightItems={rightItems} setRightItems={setRightItems} />
                </ModalBody>
                <ModalFooter>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                    <button onClick={() => { onClickExportOrders() }} type="button" className="btn btn-primary me-3">
                        {t("Export")}
                    </button>
                    <CSVLink filename={"orders_" + formatterCreateAt((new Date()).getTime(), "dmy", "Asia/Ho_Chi_Minh") + ".csv"} data={export_orders_data}>
                        <span ref={btnRef} />
                    </CSVLink>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

Modalexportorders.propTypes = {
    formatterCreateAt: PropTypes.func.isRequired,
    exportOrder: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
    order: state.order
});
const mapDispatchToProps = {
    formatterCreateAt,
    exportOrder
}

export default connect(mapStateToProps, mapDispatchToProps)(Modalexportorders);